
    export abstract class ValidatorBase {
        public abstract validate(value: string, element: HTMLInputElement, params: any): boolean;

        /**
         * For radio and checkbox elements we'll have a list of elements with the same name.
         * 
         * Searching by name will return the first, not the checked one.
         * This routine will test for checkbox or radio elements and if true, find the checked
         * element.
         * 
         * Otherwise it acts as a passthrough, returning the element by name.
         * @param name
         * @returns
         */
        protected elementByName(name: string): HTMLInputElement {
            let escapedName = this.escapeSelector(name);
            let element = document.querySelector<HTMLInputElement>(`input[name="${escapedName}"]`);

            if (!element) {
                return null;
            }

            if (element.type === "radio" || element.type === "checkbox") {
                let checkedElement = document.querySelector<HTMLInputElement>(`input[name="${escapedName}"]:checked`);

                if (checkedElement) {
                    return checkedElement;
                }
            }

            return element;
        }

        // Turns a name/id string into one that is safe for jquery to use as it cannot handle dots (which MVC outputs for sub classes in models).
        private escapeSelector(s) {
            return s.replace(/(:|\.|\[|\])/g, "\\$1");
        }
    }
